module.exports = __webpack_public_path__ + "static/images/backpack30.84ce0e8.png";